import { render } from "./newCollaborator.vue?vue&type=template&id=0ebb0523&scoped=true"
import script from "./newCollaborator.vue?vue&type=script&lang=js"
export * from "./newCollaborator.vue?vue&type=script&lang=js"

import "./newCollaborator.vue?vue&type=style&index=0&id=0ebb0523&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebb0523"]])

export default __exports__